import { Setting as Setting_kojaro } from './Setting.kojaro';
import { Setting as Setting_phosphor } from './Setting.phosphor';
import { Setting as Setting_zoomg } from './Setting.zoomg';
import { Setting as Setting_zoomit } from './Setting.zoomit';

const IconRenderer = () => {
  switch (process.env.NEXT_PUBLIC_ICON_SYSTEM) {
    case 'kojaro':
      return Setting_kojaro;

    case 'zoomg':
      return Setting_zoomg;

    case 'phosphor':
      return Setting_phosphor;

    default:
      return Setting_zoomit;
  }
};

export const Setting = IconRenderer();
